<template>
  <div class="mark-unit -card-grid -flex -around -vcenter">
    <unit :unit-slot-id="unitSlotId" :google-unit-id="googleUnitId" type="card-grid" />
  </div>
</template>

<script>
import Unit from './unit.vue'

export default {
  name: 'CardGridUnit',
  components: { Unit },
  props: {
    unitSlotId: {
      type: Number,
      required: true,
    },
    googleUnitId: {
      type: String,
      default: '1334371830',
    },
  },
}
</script>
